import api from 'api'
import type { CallStartResponse, CallTransport } from './types'

type StartAssessmentsCallRequest = {
  shiftId: number
  transport?: CallTransport
}

export const startAssessmentsCall = async (
  request: StartAssessmentsCallRequest
): Promise<CallStartResponse> => {
  const result = await api.post('/admin/coach/assessments/start_call', request)
  return result.data as CallStartResponse
}
